import {fromJS} from 'immutable';

export const navLinks = fromJS([
  {
    name: 'Explore',
    dropdown: [
      {
        name: 'For Teachers',
        hardLink: true,
        route: '/solutions-teachers'
      },
      {
        name: 'For Admins',
        hardLink: true,
        route: '/solutions-admins'
      },
      {
        name: 'Albert Adaptive | Early Access',
        hardLink: true,
        route: '/solutions/albert-adaptive'
      },
      {
        name: 'Testimonials',
        hardLink: true,
        route: '/solutions/testimonials'
      },
      {
        name: 'Case Studies',
        hardLink: true,
        route: '/case-studies'
      },
      {
        name: 'Professional Development',
        hardLink: true,
        route: '/solutions/professional-development'
      }
    ]
  },
  {
    name: 'Library'
  },
  {
    name: 'Pricing',
    hardLink: true,
    route: '/pricing-schools'
  },
  {
    name: 'Help & Resources',
    hideForNonMobile: true,
    dropdown: [
      {
        name: 'Help Docs',
        hardLink: true,
        route: 'https://help.albert.io'
      },
      {
        name: 'Live Teacher Support Session',
        hardLink: true,
        route: 'https://app.lemcal.com/@albert-adoption-team/teacher-talk'
      }
    ]
  }
]);
